module.exports = __webpack_public_path__ + "assets/img/NPC025.b0ed3ea3.png";